import { render } from "./LinesListStandardLicense.vue?vue&type=template&id=522ca4cf&scoped=true"
import script from "./LinesListStandardLicense.vue?vue&type=script&lang=js"
export * from "./LinesListStandardLicense.vue?vue&type=script&lang=js"

import "./LinesListStandardLicense.vue?vue&type=style&index=0&id=522ca4cf&scoped=true&lang=css"
/* custom blocks */
import block0 from "./LinesListStandardLicense.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522ca4cf"]])

export default __exports__